// +----------------------------------------------------------------------
// | 全局布局：顶部极简导航 + 内容区
// +----------------------------------------------------------------------
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import './Layout.less';

export default function Layout({ children }) {
  const { user, isLoggedIn, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuRef = useRef(null);

  // 换页收起菜单
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // 点外面收起菜单
  useEffect(() => {
    const onDocClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  const handleLogout = async () => {
    setMenuOpen(false);
    await logout();
    navigate('/');
  };

  const nickname = (user && (user.nickname || user.username)) || '';
  const initial = nickname ? nickname.slice(0, 1).toUpperCase() : '';

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-header-inner">
          <Link to="/" className="layout-logo">
            想想
          </Link>

          <nav className="layout-nav">
            <Link to="/chat" className="layout-nav-item">
              和想想聊
            </Link>

            <Link to="/topics" className="layout-nav-item">
              大家在纠结
            </Link>

            <Link to="/history" className="layout-nav-item">
              我的决定
            </Link>

            {isLoggedIn ? (
              <div className="layout-user" ref={menuRef}>
                <button
                  type="button"
                  className="layout-avatar"
                  onClick={() => setMenuOpen((v) => !v)}
                  title={nickname}
                >
                  {user && user.avatar ? (
                    <img src={user.avatar} alt={nickname} />
                  ) : (
                    <span>{initial}</span>
                  )}
                </button>

                {menuOpen && (
                  <div className="layout-menu">
                    <div className="layout-menu-head">
                      <strong>{nickname}</strong>
                      <span className="muted">@{user.username}</span>
                    </div>
                    <Link to="/profile" className="layout-menu-item">
                      我的资料
                    </Link>
                    <Link to="/memories" className="layout-menu-item">
                      AI 记住的我
                    </Link>
                    <Link to="/settings" className="layout-menu-item">
                      偏好设置
                    </Link>
                    <button type="button" className="layout-menu-item" onClick={handleLogout}>
                      退出登录
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link to="/login" className="layout-nav-item layout-nav-login">
                登录
              </Link>
            )}
          </nav>
        </div>
      </header>

      <main className="layout-main">{children}</main>
    </div>
  );
}
